import React, { useState } from "react";
import { useModuleBEM } from "@b2bportal/core-themes";
import { BookingType } from "@b2bportal/core-types";
import type { HotelItinerary } from "@b2bportal/lodging-api";
import { useI18nContext } from "@hopper-b2b/i18n";
import { ResendConfirmationEmailModal } from "./ResendConfirmationEmailModal";
import styles from "./styles.module.scss";
import { useResendConfirmationEmail } from "./useResendConfirmationEmail";

export type ResendConfirmationEmailProps = {
  itinerary: HotelItinerary;
  buttonClassName?: string;
};

export const ResendConfirmationEmail = ({
  itinerary,
  buttonClassName,
}: ResendConfirmationEmailProps) => {
  const [_block, cn] = useModuleBEM(styles, "ResendConfirmationEmail");
  const { t } = useI18nContext();
  const [isModalOpen, setModalIsOpen] = useState(false);

  const resendEmailHook = useResendConfirmationEmail({
    reservationBookingId: itinerary.reservation.reservationBookingId,
    bookingEmail: itinerary.reservation.bookingEmail,
    bookingType: BookingType.Lodging,
  });

  const onClick = () => {
    setModalIsOpen(true);
  };

  const onClose = () => {
    setModalIsOpen(false);
  };

  return (
    <>
      <button onClick={onClick} className={buttonClassName}>
        {t("hotels.bookingConfirmation.resendConfirmation")}
      </button>
      <ResendConfirmationEmailModal
        isOpen={isModalOpen}
        onClose={onClose}
        form={resendEmailHook.form}
        getFieldErrorText={resendEmailHook.getFieldErrorText}
        isLoading={resendEmailHook.isLoading}
        hasError={resendEmailHook.hasError}
        isSuccess={resendEmailHook.isSuccess}
        onSubmit={resendEmailHook.onSubmit}
        isFormValid={resendEmailHook.isFormValid}
        reset={resendEmailHook.reset}
        className={cn("modal-container")}
      />
    </>
  );
};
